import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import { colors, typography } from '../../styles/theme';
import ModalStickyFooter from '../ui/ModalStickyFooter';

interface CustomPuzzleGreetingModalProps {
  visible: boolean;
  onClose: () => void;
  onPlay: () => void;
  isLoading?: boolean;
}

export default function CustomPuzzleGreetingModal({ visible, onClose, onPlay, isLoading }: CustomPuzzleGreetingModalProps) {
  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      isFullScreenOnMobile={false}
      header={<Text style={modalStyles.headerText}>Play Custom Puzzle</Text>}
      footer={(
        <ModalStickyFooter>
          <HoverButton
            style={modalStyles.primaryButton}
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onPlay}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Play Custom Puzzle"}
          </HoverButton>
        </ModalStickyFooter>
      )}
    >
      <View style={styles.container}>
        <Text style={styles.bodyText}>
          You have been invited to play a custom puzzle created by another player!
        </Text>
      </View>
    </BaseModal>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 20,
    paddingHorizontal: 8,
  },
  bodyText: {
    ...typography.body,
    color: colors.textMuted,
    textAlign: 'center',
    lineHeight: 24,
  },
});
